import { render, staticRenderFns } from "./koufeixinxibiangeng.vue?vue&type=template&id=9976d7d0&scoped=true&"
import script from "./koufeixinxibiangeng.vue?vue&type=script&lang=js&"
export * from "./koufeixinxibiangeng.vue?vue&type=script&lang=js&"
import style0 from "./koufeixinxibiangeng.vue?vue&type=style&index=0&id=9976d7d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9976d7d0",
  null
  
)

export default component.exports